// Entry point for the build script in your package.json
import Rails from '@rails/ujs'
import Alpine from 'alpinejs'
import './tailadmin'
import './companies_index'
import './delivery_groups_edit'
import './sidebar_toggle'
import './shared/toast_notifications'
import './shared/industry_tree_select'
import './delivery_results_show'
import './stats_loader'
import './stats_tabs'
import './multiple_campaigns'

// Start Rails UJS
Rails.start()

// Initialize Alpine.js
window.Alpine = Alpine
Alpine.start()

console.log("Rails application started")
